import { useTranslation } from 'react-i18next'
import Avatar from 'react-avatar'
import PropTypes from 'prop-types'

import { ContactLines } from './personIcons'
import SupporterLists from './SupporterLists'

import styles from '../style.module.scss'

/**
 * Abschnitt „Wirtschaftsexperten".
 *
 * Hier stehen seit 08.08.2026 **beide** Verzeichnisse untereinander, weil sie
 * sonst zwei unabhaengige Zahlen an zwei Menuepunkten ergaben:
 *
 * 1. die Wirtschaftsexpert:innen, die die Junior Company selbst eingetragen hat
 *    (Tabelle `Experts`, Voraussetzung fuer die Aktivierung) — eigenstaendige
 *    Eintraege ohne Profil im Bereich Unterstuetzer:innen,
 * 2. die Unterstuetzer:innen aus dem Verzeichnis von Junior Achievement, mit
 *    denen die Junior Company verbunden ist bzw. die zu ihr passen wuerden.
 *
 * Zuweisen kann die Verwaltung in beiden Faellen niemanden — warum, steht im
 * Unterpunkt „Kurzanleitung" (siehe ExpertsFlowTab).
 *
 * Seit 06.10.2026 steht das erste Verzeichnis nur noch da, solange es Eintraege
 * hat: Anlegen geht seit 09.08.2026 nicht mehr, und auf Prod gibt es keinen
 * einzigen. Die leere Zeile „(0) — Voraussetzung fuer die Aktivierung" las sich
 * wie der Grund, warum der Knopf gesperrt war (#193) — gezaehlt werden fuer die
 * Aktivierung aber die verbundenen Unterstuetzer:innen darunter.
 */
export default function ExpertsTab({ companyId, experts, avatarUrls, supportersUrl }) {
	const { t } = useTranslation()
	const hasOwnExperts = experts?.length > 0

	return (
		<div className={styles.stack}>
			{/* Der Satz steht vor den Listen, nicht darunter: Er beantwortet die
			    Frage, die beim Lesen der beiden Zahlen entsteht. */}
			{hasOwnExperts && <p className={styles.blockNote}>{t('Two expert registers')}</p>}

			{hasOwnExperts && (
				<section className={styles.block}>
					<div className={styles.blockHead}>
						<h3 className={styles.blockTitle}>
							{t('Own economic experts')} ({experts?.length || 0})
						</h3>
					</div>
					<p className={styles.blockNote}>{t('Own economic experts hint')}</p>
					<div className={styles.peopleGrid}>
						{experts.map(item => (
							<div key={item.id} className={styles.contactCard}>
								<span className={styles.employeeProfile}>
									<Avatar
										className={styles.userAvatar}
										round
										size={32}
										name={`${item.firstName} ${item.lastName}`}
										src={avatarUrls[item.avatarHashName] || ''}
									/>
									<p className={styles.name}>
										{item.firstName} {item.lastName}
									</p>
								</span>
								<ContactLines email={item.email} phone={item.phone} />
							</div>
						))}
					</div>
				</section>
			)}

			<SupporterLists companyId={companyId} listUrl={supportersUrl} />
		</div>
	)
}

ExpertsTab.propTypes = {
	companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	experts: PropTypes.array,
	avatarUrls: PropTypes.object.isRequired,
	// Ohne Angabe fragt SupporterLists die Adresse der Verwaltung.
	supportersUrl: PropTypes.func
}
